/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

import * as React from 'react';
import { Popover } from '../popover';
import { mergeOverrides } from '../helpers/overrides';
import baseDefaultProps from './default-props';
import type { TooltipProps } from './types';
import { Arrow as StyledArrow, Body as StyledBody, Inner as StyledInner } from './styled-components';
class Tooltip extends React.Component<TooltipProps> {
  static defaultProps: Partial<TooltipProps> = {
    ...baseDefaultProps
  };
  render() {
    const overrides = mergeOverrides({
      Arrow: StyledArrow,
      Body: StyledBody,
      Inner: StyledInner
    }, this.props.overrides);
    return <Popover autoFocus={false} data-baseweb="tooltip" {...this.props} overrides={overrides} />;
  }
}
export default Tooltip;